import { render, staticRenderFns } from "./SMSreport.vue?vue&type=template&id=40e81c64&"
import script from "./SMSreport.vue?vue&type=script&lang=js&"
export * from "./SMSreport.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports